import styled from 'styled-components';
import { Paragraph, spaceMixin, token } from '@zillow/constellation';

export const Container = styled.div`
    padding: ${spaceMixin('sm')} 0;
    border-top: 1px solid ${token('colors.gray300')};
    ${({ borderBottom }) => borderBottom && `
        border-bottom: 1px solid #D1D1D5;
    `};
`;

export const Header = styled.div`
    display: flex;
    width: 100%;
`;

export const SecondaryText = styled(Paragraph)`
    && {
        color: #596B82;
    }
`;
